import { DEFAULT_INVOICE_FEE, DEFAULT_SETUP_FEE } from "./constants";

export const Calc = {
	// Privata metoder
	calculateLeasing: (amount: number, downpayment: number, time: number, interest: number, salvagevalue: number) => {
		return (
			((amount -
				(amount * downpayment) / 100 -
				(amount * (salvagevalue / 100)) / Math.pow(1 + interest / 100 / 12, time)) *
				interest) /
			100 /
			12 /
			((1 - Math.pow(1 + interest / 100 / 12, time * -1)) * (1 + interest / 100 / 12))
		);
	},

	calculateCar: (amount: number, downpayment: number, time: number, interest: number, salvagevalue: number) => {
		return (
			((amount -
				(amount * downpayment) / 100 -
				(amount * (salvagevalue / 100)) / Math.pow(1 + interest / 100 / 12, time)) *
				(interest / 100 / 12)) /
			(1 - Math.pow(1 + interest / 100 / 12, time * -1))
		);
	},

	calculateLoanFreeTime: (amount: number, downpayment: number, time: number, interest: number) => {
		return (
			((amount - (amount * downpayment) / 100) * (interest / 100 / 12)) /
			(1 - Math.pow(1 + interest / 100 / 12, time * -1))
		);
	},

	calculateLoan: (amount: number, time: number, interest: number) => {
		return (amount * interest) / 100 / 12 / (1 - Math.pow(1 + interest / 100 / 12, time * -1));
	},

	lEvalRate: (
		rate: number,
		numberOfPeriods: number,
		payment: number,
		presentValue: number,
		futureValue: number,
		due: number
	) => {
		if (rate == 0.0) {
			return presentValue + payment * numberOfPeriods + futureValue;
		}

		const lEvalRate1 = Math.pow(rate + 1.0, numberOfPeriods);
		const lEvalRate2 = 0 == due ? 1.0 : 1.0 + rate;
		return presentValue * lEvalRate1 + (payment * lEvalRate2 * (lEvalRate1 - 1.0)) / rate + futureValue;
	},

	rate: (
		numberOfPeriods: number,
		payment: any,
		presentValue: any,
		futureValue: number,
		due?: number,
		guess?: number
	) => {
		if (numberOfPeriods <= 0.0) {
			throw "numberOfPeriods must be greater than zero";
		}

		futureValue = futureValue || 0.0;
		due = due || 0;
		guess = guess || 0.1;
		let rateUpperBoundary = guess;
		let lEvalRate1 = Calc.lEvalRate(rateUpperBoundary, numberOfPeriods, payment, presentValue, futureValue, due);
		let rateLowerBoundary = lEvalRate1 <= 0.0 ? rateUpperBoundary * 2.0 : rateUpperBoundary / 2.0;
		let lEvalRate2 = Calc.lEvalRate(rateLowerBoundary, numberOfPeriods, payment, presentValue, futureValue, due);
		let i = 0;

		do {
			if (lEvalRate2 == lEvalRate1) {
				rateUpperBoundary -= 1e-5;
				lEvalRate1 = Calc.lEvalRate(rateUpperBoundary, numberOfPeriods, payment, presentValue, futureValue, due);
				if (lEvalRate2 == lEvalRate1) {
					throw "Inputs will cause division by zero.";
				}
			}
			const temporaryRate =
				rateLowerBoundary - ((rateLowerBoundary - rateUpperBoundary) * lEvalRate2) / (lEvalRate2 - lEvalRate1);
			const lEvalRate3 = Calc.lEvalRate(temporaryRate, numberOfPeriods, payment, presentValue, futureValue, due);
			if (Math.abs(lEvalRate3) < 1e-7) {
				return temporaryRate;
			}

			lEvalRate1 = lEvalRate2;
			lEvalRate2 = lEvalRate3;
			rateUpperBoundary = rateLowerBoundary;
			rateLowerBoundary = temporaryRate;
			i++;
		} while (i <= 39);

		throw "Cannot calculate rate";
	},

	calculateEffectivRate: (
		financedAmount: number,
		numberOfMonths: number,
		monthCost: any,
		salvagevalueAmount: number
	) => {
		const paymentPeriod = 1;
		const numberOfPeriods = 12 / paymentPeriod;

		const nominalRate = Calc.rate(
			numberOfMonths / paymentPeriod,
			-(monthCost + DEFAULT_INVOICE_FEE),
			financedAmount - DEFAULT_SETUP_FEE,
			-salvagevalueAmount
		);

		const result =
			Math.pow(1 + (nominalRate * numberOfPeriods * 100) / (100 * (12 / paymentPeriod)), numberOfPeriods) - 1;

		return result * 100;
	},
};
